import {
  DEFAULT_MILESTONE_COLOR,
  DEFAULT_MILESTONE_ICON,
} from '../../../domain/entity/MilestoneEntity'

export type ApiError = {
  code: string
  detail: string
}

export type FormState = {
  wbsItemUuid?: string
  name: string
  milestoneDate: string
  description: string
  iconName: string
  color: string
  achieved: boolean
}

export const INITIAL_FORM_STATE: FormState = {
  name: '',
  milestoneDate: '',
  description: '',
  iconName: DEFAULT_MILESTONE_ICON,
  color: DEFAULT_MILESTONE_COLOR,
  achieved: false,
}

export const PRESET_ICONS = [
  'mdi:rhombus',
  'mdi:star',
  'mdi:flag',
  'mdi:checkbox-marked',
  'mdi:package-variant-closed',
  'mdi:calendar-star',
]

export const PRESET_COLORS = [
  '#FF0000',
  '#ed6c02',
  '#ffc107',
  '#2e7d32',
  '#1976d2',
  '#9c27b0',
  '#000000',
]

/** 対象が解決できていない(取得前・対象が削除済み等)ときの表示 */
export const UNRESOLVED_TARGET_LABEL = '…'
